export default "__VITE_ASSET__17dc3f64__"